import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { featureFlagQueryKeys } from "./featureFlagQueryKeys";
import * as UseDeletedFeatureFlags from "./useDeletedFeatureFlags";
import * as UseFeatureFlags from "./useFeatureFlags";

export function useDeleteFeatureFlag() {
  const { featureFlagService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (featureFlagId) => featureFlagService.delete(featureFlagId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseFeatureFlags.getQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: UseDeletedFeatureFlags.getQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: featureFlagQueryKeys.states(),
      });
    },
  });
}
